__turbopack_context__.v({
  "active": "styles-module-scss-module__Y_k48G__active",
  "modelLink": "styles-module-scss-module__Y_k48G__modelLink",
  "modelsContainer": "styles-module-scss-module__Y_k48G__modelsContainer",
  "popularModels": "styles-module-scss-module__Y_k48G__popularModels",
});
